function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .catch((error) => {
      console.error('Não foi possível registrar o aplicativo instalável:', error)
    })
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type')
      if (
        response.status === 404
        || (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
        return
      }
      registerValidSW(swUrl)
    })
    .catch(() => {})
}

function reloadWhenUpdated() {
  let refreshing = false
  const hadController = Boolean(navigator.serviceWorker.controller)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || refreshing) return
    refreshing = true
    window.location.reload()
  })
}

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return
  reloadWhenUpdated()

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
  if (publicUrl.origin !== window.location.origin) return

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
    const isLocalhost = Boolean(
      window.location.hostname === 'localhost'
      || window.location.hostname === '[::1]'
      || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
    )
    if (isLocalhost) checkValidServiceWorker(swUrl)
    else registerValidSW(swUrl)
  })
}
